

module.exports = __webpack_require__.stylable.create(
    "Details556046739",
    {"classes":{"root":"Details556046739__root","box":"Details556046739__box","srOnly":"Details556046739__srOnly","locationDivider":"Details556046739__locationDivider"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "Details556046739",
    null
);
